import { render, staticRenderFns } from "./TournamentsForm.vue?vue&type=template&id=8e9b0f8a&scoped=true"
import script from "./TournamentsForm.vue?vue&type=script&lang=js"
export * from "./TournamentsForm.vue?vue&type=script&lang=js"
import style0 from "./TournamentsForm.vue?vue&type=style&index=0&id=8e9b0f8a&prod&lang=scss"
import style1 from "./TournamentsForm.vue?vue&type=style&index=1&id=8e9b0f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9b0f8a",
  null
  
)

export default component.exports